type Statuses = 'NOT_EXISTS' | 'READY' | 'DELETED' | 'PENDING' | 'UPLOADING'

export const TrainingStatus: Record<Statuses, string> = {
  NOT_EXISTS: 'NOT_EXISTS',
  PENDING: 'PENDING',
  READY: 'READY',
  DELETED: 'DELETED',
  UPLOADING: 'UPLOADING',
}

/** Only in-progress PENDING means the bot is training — FAILED/NOT_TRAINED need a Train CTA. */
export const getTrainingStatusFromSources = (sources: Array<{ status?: string }> = []): string => {
  const isTraining = sources.some(source => source.status === TrainingStatus.PENDING)
  return isTraining ? TrainingStatus.PENDING : TrainingStatus.READY
}
